var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.notificationsShow
    ? _c("div", { staticClass: "popup", staticStyle: { position: "fixed" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.contentShow,
                expression: "contentShow"
              }
            ],
            staticClass: "notifiy-content",
            staticStyle: { position: "fixed" },
            attrs: { id: "notifications" }
          },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\r\n                " +
                  _vm._s(_vm.$t("language.rightTopBanner.notification")) +
                  "\r\n                "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                attrs: { id: "dialogClose" },
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "notification-content" }, [
              _c("div", {
                attrs: { id: "notificationContainer" },
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("language.popup.addCloudPopup.notificationTip")
                  )
                }
              }),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.4.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2024/12/31")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Online Video Downloader")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Download high-quality videos from YouTube, Facebook, X, TikTok, and 1000+ other sites with MultCloud's ad-free, cross-platform Online Video Downloader—no installation required."
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "Try these new features now and elevate your file management experience with MultCloud!"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2024/12/27")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v("Web Image Downloader")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Effortlessly collect images from any website or Google search by entering a URL or keyword and save them directly to your cloud storage or local device."
                  )
                ]),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    "Try these new features now and elevate your file management experience with MultCloud!"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2024/11/08")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "We are excited to announce new features and enhancements in MultCloud:"
                  )
                ]),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.1.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2024/06/27")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "We are excited to introduce the new Image Saver feature in MultCloud! Here are the details of the new functionalities:"
                  )
                ]),
                _vm._v(" "),
                _vm._m(1)
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("b", [
                _vm._v(
                  _vm._s(_vm.$t("language.popup.addCloudPopup.notAbleAccess"))
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t("language.popup.addCloudPopup.problemNotAccess")
                  )
                )
              ]),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "7.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2024/05/09")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("MultCloud now supports 4shared and lDrive e2.")
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "6.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2024/02/29")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("MultCloud now supports Icedrive.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "6.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2024/01/30")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Chrome Extensions: MultCloud Save - Save Webpage as PDF."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "5.5.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2023/09/11")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("MultCloud now supports Outlook.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "5.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2023/06/30")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("MultCloud now supports iCloud Drive.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "5.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2023/05/31")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("MultCloud now supports Gmail.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "5.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2023/03/15")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("MultCloud now supports iCloud Photos.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.9.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2023/02/14")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("Bug fixes on cloud backup and restore.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.8.7"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2022/07/07")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("SharePoint online storage supported.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.8.5"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2022/06/08")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("Share Transfer.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "With this feature, you can deliver large files to anyone easily."
                  )
                ]),
                _vm._v(" "),
                _c("b", [_vm._v("Quick Guide :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Right click on the file you'd like to send (in order to select the file, please add the cloud where the file exists to Multcloud first)."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    '2.Navigate to "Share" and select "Create a Transfer".'
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.8.2"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2022/05/30")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("Wasabi Cloud Added.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("Wasabi users can now connect Wasabi to MultCloud.")
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.8.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2022/01/20")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [_vm._v("Team Transfer.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Easily to migrate business clouds from one tenant to another. Google Workspace (and Shared Drive), OneDrive for Business, Dropbox Business, Box for Business supported."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.7.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2021/11/05")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("Cloud-to-cloud backup and restore feature added.")
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.6.8"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2021/09/30")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("All clouds are supported for Real-time Sync.")
                ]),
                _vm._v(" "),
                _c("b", [_vm._v("Improved :")]),
                _vm._v(" "),
                _c("div", [_vm._v("UI improved on sharing page.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.6.7"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("Released on 2021/07/01")]),
                _vm._v(" "),
                _c("b", [_vm._v("New :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Cloud-to-cloud sync tasks now support real time sync."
                  )
                ]),
                _vm._v(" "),
                _c("b", [_vm._v("Improved :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Speed improvements for new created transfer and sync tasks."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.6.5"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Released new UI.")]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Supported uploading torrent to cloud.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.7"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Added NAS.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.6"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Fixed the problem that Google Photos could not be accessed."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.5"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Improve the function of sharing MultCloud for free traffic."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.4"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add Multi-Source transfer function.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("2.Add Online File Encryption and Decryption.")
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "3.Add Filename Encryption option to File Encryption function."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.3"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Optimize Dropbox for Business cloud.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.2"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("1.New premium feature: File Uploading Encryption.")
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("1.Improvements to MultCloud transport server.")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Free and premium plan updated.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.5.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add recycle bin for some clouds.")]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Modify some interfaces of our website.")]),
                _vm._v(" "),
                _c("div", [_vm._v("3.Optimize some functions.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.4"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add Google Photos and Put.io.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.3"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add One-way Multi-target Sync function.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.2"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add Backblaze.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add Google Drive for G Suite.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.4.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add Sub-Accounts Management.")]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Improve Google cloud drive.")]),
                _vm._v(" "),
                _c("div", [_vm._v("3.Fix some cloud drive bugs.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.3.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Improve OneDrive for Business authorization function and solve the problem that some users can not add this cloud."
                  )
                ]),
                _vm._v(" "),
                _c("b", [_vm._v("Note :")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "Please re-add your OneDrive for Business cloud and transfer tasks for users that have added this cloud, sorry for the inconvenience."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Added support for pCloud drive.")]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Fix some cloud drive bugs.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("1.Multilanguage adds German and traditional Chinese.")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Improve Dropbox cloud drive.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "3.Improve share feature and add upload & new folder actions in share page."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.1.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add points system.")]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Add history-error view feature.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("3.Add manual retry button when transfer fails.")
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("4.Improve search, share, transfer progress features.")
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "4.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Add Cloud Synchronization function, include one -way sync,two-way sync and so on."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "2.Added support for OneDrive for Business, Dropbox for Business and Egnyte cloud drives."
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("3.Improve Share function.")]),
                _vm._v(" "),
                _c("div", [_vm._v("4.Improve UI.")]),
                _vm._v(" "),
                _c("div", [_vm._v("5.Fix transfer bugs.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.8.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Upgrade share function, add folder share, share management, save share, transfer share functions."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v('2.Add "Upload URL" option in upload function.')
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("3.Fix some cloud drive bugs.")]),
                _vm._v(" "),
                _c("div", [_vm._v("4.Remove Copy cloud drive.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.7.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add mega and Evernote cloud drives.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "2.Add preview support of text files, such as txt, html, js."
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("3.Optimize the schedule tasks.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "4.Fix the bug of transfering Google documents between Google Drives to keep file types consistent."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "5.Amazon S3 support that transfering a singal file greater than 5 Gb."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.6.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add hubiC cloud drive.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    '2.Add"Experience without signing up" function for quick experience.'
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    '3.Add "Go to official site" function for some cloud drives.'
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "4.Fix transmission bugs of OneDrive and Google Drive."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.5.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Improve the speed of cross-cloud transmission for VIP users."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("2.Add MySQL backup and Flickr cloud drive.")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("3.Fix some bugs of schedule transfer.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "4.Fix the bug that can not list files of FTP and WebDav."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.4.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add MediaFire to MultCloud.")]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Add OwnCloud to MultCloud.")]),
                _vm._v(" "),
                _c("div", [_vm._v("3.Modify the scheduled file transfer.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add Alfreco to MultCloud.")]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Add aDrive to MultCloud.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "3.Modify the break exception for transmission across the different clouds."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v('1.Added the "replacement" option.')]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("2.Upgrade OneDrive API, and remove some limits.")
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("3.Modified the bug of amazon cloud drive.")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("4.Optimize transmission environment.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.1.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Support Amazon cloud drive.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "2.Support replacing or skipping some files during file transfer."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "3.Enhance SFTP service: Support logging in with Private key."
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("4.Optimize transfer function.")]),
                _vm._v(" "),
                _c("div", [_vm._v("5.Fixed some cloud drive bugs.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "3.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("1.Add new functions as Transfer and Task Manager.")
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "2.Support setting of Scheduled Transfer and File Filter."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "3.Support notifying by emailing automatically after transferring."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "4.Support re-edit the accounts and view the properties of cloud drives."
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("5.Adjust and optimize some UIs.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "6.Enhance the stability and speed of transfer by optimizing the network environment."
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("7.Fixed some bugs.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.3.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    '1.Remove the "background" button, and all the transmission tasks will be set to background as default.'
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Fixed some bugs.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.3.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("1.Add the function of background transmission.")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Improve the transmission ability.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "3.Add the function of showing the sizes of cloud drives."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.2.2"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Add the function for displaying a right-click menu for tablets, mobile devices."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "2.Modify the exceptions about register, find password. Also allows you to skip activation for using MultCloud."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "3.Modify the exception that it's unable to add the server address which begins with http for WebDav."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.2.1"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Modify the exceptions about list,search,copy files of Google Drive."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.2.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Modify the bulk transmission exceptions for the higher transmission stability."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "2.Add the function that scanning the details of transmission progress."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.1.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "1.Modify the problem that file lists display incompletely."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "2.Modify the exceptions about file upload,download and transmission in FTP."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "3.Modify the break exception for transmission across the different clouds."
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("4.Modify the UI of adding FTP and WebDav.")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("5.Add some notes for each cloud drive.")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", [
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("language.popup.addCloudPopup.version")) +
                      "2.0.0"
                  )
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("1.Add FTP to MultCloud.")]),
                _vm._v(" "),
                _c("div", [_vm._v("2.Add WebDav to MultCloud.")]),
                _vm._v(" "),
                _c("div", [_vm._v('3.Add the menu option:"Copy to".')]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("4.Login with Google and Facebook Account.")
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("5.Improve user-interface to more easy-to-use.")
                ]),
                _vm._v(" "),
                _c("div", [_vm._v("6.Some bug fixes.")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "7.Support Cubby, MyDrive, Web.de, Yandex, CloudMe, HiDrive, Copy and BaiDu."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("br")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "notificate-footer" }, [
              _c(
                "div",
                {
                  staticStyle: {
                    float: "left",
                    position: "relative",
                    top: "8Px",
                    "line-height": "30Px"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.checkBox()
                    }
                  }
                },
                [
                  _c("span", {
                    staticClass: "icon-util  notification-check-position",
                    class: _vm.check ? "check-small" : "nocheck-small",
                    attrs: { id: "checkIcon" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.checkBox()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "notice-text" }, [
                    _vm._v(
                      _vm._s(_vm.$t("language.popup.addCloudPopup.noPrompt"))
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticStyle: {
                    float: "right",
                    "margin-right": "10Px",
                    width: "110Px",
                    position: "relative",
                    top: "8Px"
                  },
                  on: {
                    click: function($event) {
                      return _vm.sure()
                    }
                  }
                },
                [_vm._v("OK")]
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "imagesaver_versions" }, [
      _c("li", [
        _c("b", [_vm._v("Instagram Downloader:")]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "You can now easily download Instagram content! With the new Instagram Downloader, users can download or upload Instagram Profile Pictures, Posts, Reels, Stories, and Highlights directly to cloud storage or to your local device."
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", [
          _vm._v(
            "Video Downloader and Image Downloader feature will also be available soon."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", { staticClass: "imagesaver_versions" }, [
      _c("li", [
        _c("b", [_vm._v("Save Instagram Images and Videos")]),
        _vm._v(" "),
        _c("ul", { staticClass: "imagesaver_version" }, [
          _c("li", { attrs: { type: "disc" } }, [
            _c("b", [_vm._v("Multiple Links Support: ")]),
            _vm._v(
              "Save images and videos from 1-3 Instagram links simultaneously."
            )
          ]),
          _vm._v(" "),
          _c("li", { attrs: { type: "disc" } }, [
            _c("b", [_vm._v("Easy Upload and Download: ")]),
            _vm._v(
              "Choose to upload media directly to your cloud storage or download it to your local device."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [_vm._v("Save Website Images")]),
        _vm._v(" "),
        _c("ul", { staticClass: "imagesaver_version" }, [
          _c("li", { attrs: { type: "disc" } }, [
            _c("b", [_vm._v("Multiple Links Support: ")]),
            _vm._v("Save images from 1-3 website links at once.")
          ]),
          _vm._v(" "),
          _c("li", { attrs: { type: "disc" } }, [
            _c("b", [_vm._v("Flexible Storage Options: ")]),
            _vm._v(
              "Upload images directly to your preferred cloud storage or download them locally."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [_vm._v("Save Google Search Images")]),
        _vm._v(" "),
        _c("ul", { staticClass: "imagesaver_version" }, [
          _c("li", { attrs: { type: "disc" } }, [
            _c("b", [_vm._v("Keyword-Based Search: ")]),
            _vm._v("Enter a keyword to search for images on Google.")
          ]),
          _vm._v(" "),
          _c("li", { attrs: { type: "disc" } }, [
            _c("b", [_vm._v("Direct Save: ")]),
            _vm._v(
              "Easily upload search results to your cloud storage or download them to your computer."
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56b3c4ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56b3c4ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/notifications_popup.vue
// module id = null
// module chunks = 